import React from "react";
import "./Login.scss";
import PublicAuthFormWrapper from "../../components/auth/PublicAuthFormWrapper";
import ResetPasswordForm from "../../components/auth/ResetPasswordForm";

export default function PublicResetPassword() {
  return (
    <PublicAuthFormWrapper title='Set New Password' documentTitle='Set New Password'>
      <ResetPasswordForm />
    </PublicAuthFormWrapper>
  );
}
